import { Coupon } from "../CouponInput";

export function renderSubscriptionExplanation({
  plan,
  changeType,
  coupon,
  referralSlug,
}: {
  plan: {
    a2pFeePrice: string;
    automatedSmsOverageRate: string;
    voicemailOverageRate: string;
    trialPeriodDays: number;
    price: string;
  };
  changeType: "signUp" | "upgrade" | "reactivation" | "trialCompletion";
  coupon?: Coupon;
  referralSlug?: string;
}) {
  const planPrice = coupon
    ? coupon.apply(Number(plan.price))
    : Number(plan.price);
  const a2pFeePrice = Number(plan.a2pFeePrice);
  const automatedSmsOverageRate = Number(plan.automatedSmsOverageRate);
  const voicemailOverageRate = Number(plan.voicemailOverageRate);

  const isTrial = plan.trialPeriodDays > 0;

  const formatPrice = (price: number) => {
    return (
      "$" +
      price.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  if (!planPrice) {
    return null;
  }

  let firstChargeExplanation = "";
  if (changeType === "upgrade") {
    firstChargeExplanation = `Your card will be charged the prorated amount of the upgrade immediately. Your billing date will remain the same. Starting on your next billing date, your card will be charged your new monthly subscription price of ${formatPrice(
      planPrice
    )}`;
  } else if (isTrial && changeType === "signUp") {
    firstChargeExplanation = `After a ${
      plan.trialPeriodDays
    } day trial, your card will be charged your monthly subscription price of ${formatPrice(
      planPrice
    )}`;
  } else if (referralSlug) {
    firstChargeExplanation = `Your card will be charged the discounted price of ${formatPrice(
      planPrice - 10.0
    )} for your first month. Going forward, your card will be charged your monthly subscription price of ${formatPrice(
      planPrice
    )}`;
  } else {
    firstChargeExplanation = `Your card will be charged your monthly subscription price of ${formatPrice(
      planPrice
    )}`;
  }

  if (a2pFeePrice) {
    firstChargeExplanation += `, plus ${formatPrice(
      a2pFeePrice
    )} for industry fees.`;
  } else {
    firstChargeExplanation += ".";
  }

  let subscriptionAgreement =
    " By signing up, you authorize Skipio to automatically renew this subscription on the same day each month. Refunds are not issued for accounts canceled after their monthly renewal date.";

  if (isTrial && changeType !== "trialCompletion") {
    subscriptionAgreement +=
      " Cancel at any time during your trial to avoid being charged.";
  }

  const overageFeeExplanation = voicemailOverageRate
    ? ` Overages of ${formatPrice(
        automatedSmsOverageRate
      )} apply for each SMS message you send and ${formatPrice(
        voicemailOverageRate
      )} for each Voicemail you send over your limit for the current month.`
    : ` Overages of ${formatPrice(
        automatedSmsOverageRate
      )} apply for each SMS message you send over your limit for the current month.`;

  let subscriptionExplanation = "";
  subscriptionExplanation += firstChargeExplanation;

  if (["signUp", "trialCompletion", "reactivation"].includes(changeType)) {
    subscriptionExplanation += subscriptionAgreement;
  }

  if (automatedSmsOverageRate) {
    subscriptionExplanation += overageFeeExplanation;
  }

  return subscriptionExplanation;
}
